import React from 'react';
import $ from 'jquery';
import { ts } from 'src/utils/translate';

const useCloneSvg = ({ downloadedUrl, baseSvg }: { downloadedUrl: any; baseSvg: any }) => {
  const [cloneSvg, setCloneSvg] = React.useState<any>(null);

  const baseSvgLoaded = baseSvg && baseSvg.floorHTML;

  React.useEffect(() => {
    if (baseSvgLoaded && downloadedUrl) {
      let svgImg = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "image"
      );
      svgImg.setAttributeNS(null, "height", "900");
      svgImg.setAttributeNS(null, "width", "900");
      svgImg.setAttributeNS(
          "http://www.w3.org/1999/xlink",
          "href",
          downloadedUrl
      );
      svgImg.setAttributeNS(null, "x", "0");
      svgImg.setAttributeNS(null, "y", "0");
      svgImg.setAttributeNS(null, "style", "opacity: 0.8");

      const clone = $(baseSvg.floorHTML);
      clone.find(".devices").before(svgImg);
      setCloneSvg(
          <div dangerouslySetInnerHTML={{ __html: clone[0].outerHTML }}></div>
      );
    }
  }, [baseSvgLoaded, downloadedUrl]);

  return { cloneSvg, baseSvgLoaded };
};

export const LightingCalculation = (props: any) => {
  const { enabled, lightingData, baseSvg } = props;

  const { cloneSvg, baseSvgLoaded } = useCloneSvg({
    downloadedUrl: lightingData.url,
    baseSvg: baseSvg,
  });

  const downloadFailed = lightingData.status === "dl_error";

  if (!enabled || downloadFailed || !baseSvgLoaded) return null;

  return (
      <React.Fragment>
        <h3 className="break-before">{ts("docu_lightcalc_heading", "Lighting Calculation")}</h3>
        {!cloneSvg ? (
            <div
                style={{
                  background: "#f7f7f7",
                  width: "100%",
                  height: 300,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
            >
              <i
                  className="fa fa-cog fa-spin"
                  style={{ fontSize: 50, color: "var(--uplan-blue)" }}
              ></i>
            </div>
        ) : (
            <div
                style={{ position: "relative", animation: "fadein 0.5s" }}
                className={`quote-map lighting-calculation`}
            >
              {cloneSvg}
            </div>
        )}
      </React.Fragment>
  );
};
